import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { optimizeImageForUpload } from './imageOptimization';

async function callFunction(name, payload) {
  if (!functions) throw new Error('Firebase Functions are not configured.');
  const callable = httpsCallable(functions, name);
  const result = await callable(payload);
  return result.data;
}

export const createAdminAccount = (payload) => callFunction('createAdmin', payload);
export const updateAdminAccount = (payload) => callFunction('updateAdmin', payload);
export const removeAdminAccount = (payload) => callFunction('removeAdmin', payload);
export const resetAdminPassword = (payload) => callFunction('resetAdminPassword', payload);
export const sendAnnouncementNotification = (payload) => callFunction('sendAnnouncementNotification', payload);
export const sendRecordNotification = (payload) => callFunction('sendRecordNotification', payload);
export const sendCustomPushNotification = (payload) => callFunction('sendCustomPushNotification', payload);
export const getOneSignalStatus = () => callFunction('getOneSignalStatus', {});
export const setOneSignalConfig = (payload) => callFunction('setOneSignalConfig', payload);
export const setAnnouncementAdminPermissions = (payload) => callFunction('setAnnouncementAdminPermissions', payload);

export const commitCloudinaryUploads = (uploadIds) => callFunction('commitCloudinaryUploads', { uploadIds });
export const discardCloudinaryUploads = (uploadIds) => callFunction('discardCloudinaryUploads', { uploadIds });
export const cleanupRemovedCloudinaryAssets = (payload) => callFunction('cleanupRemovedCloudinaryAssets', payload);
export const runCloudinaryOrphanCleanup = () => callFunction('cleanupCloudinaryOrphans', {});

export async function uploadToCloudinary(file, collectionName) {
  const optimized = await optimizeImageForUpload(file, {
    maxDimension: 1600,
    quality: 0.82,
  });
  const uploadFile = optimized.file;

  const signature = collectionName === 'announcements'
    ? await callFunction('signAnnouncementImageUpload', {})
    : await callFunction('signCloudinaryUpload', { collectionName });
  const form = new FormData();
  form.append('file', uploadFile);
  form.append('api_key', signature.apiKey);
  form.append('timestamp', String(signature.timestamp));
  form.append('public_id', signature.publicId);
  form.append('tags', signature.tags);
  form.append('signature', signature.signature);

  const response = await fetch(`https://api.cloudinary.com/v1_1/${signature.cloudName}/image/upload`, {
    method: 'POST',
    body: form,
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result?.error?.message || 'Cloudinary upload failed.');

  const optimizedUrl = String(result.secure_url || '').replace(
    '/image/upload/',
    '/image/upload/f_auto,q_auto,c_limit,w_1600/',
  );

  return {
    url: optimizedUrl || result.secure_url,
    publicId: result.public_id,
    uploadId: signature.uploadId || '',
    optimization: {
      convertedToWebp: optimized.converted,
      originalBytes: optimized.originalBytes,
      uploadedBytes: optimized.uploadedBytes,
      width: optimized.width,
      height: optimized.height,
      fallbackReason: optimized.reason || '',
    },
  };
}
